import ScrollAnimator from './animators/ScrollAnimator.js';
import ParallaxAnimator from './animators/ParallaxAnimator.js';
import ScrollZoomAnimator from './animators/ScrollZoomAnimator.js';
import TextAnimator from './animators/TextAnimator.js';
import TypewriterAnimator from './animators/TypewriterAnimator.js';
import ClipPathAnimator from './animators/ClipPathAnimator.js';
import '../styles/fade.css';
import '../styles/slide.css';
import '../styles/zoom.css';
import '../styles/scroll-zoom.css';
import '../styles/text-animations.css';
import '../styles/text-typewriter.css';
import '../styles/ClipPathAnimator.css'

// Aquí añadirás otros módulos

document.addEventListener('DOMContentLoaded', () => {
  new ScrollAnimator();
  new ParallaxAnimator();
  new ScrollZoomAnimator();
  new TextAnimator();
  new TypewriterAnimator();
  new ClipPathAnimator();
});
